/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable:no-any */ // Need to support all data types
import { Injectable } from '@angular/core';
import { Wove } from 'aspect.js/';
import { throwError as observableThrowError, Observable, Subject } from 'rxjs';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { ApiGatewayService } from '@core/api/services/api-gateway-service';
import { ClearCacheResponse } from '@support/shared/interfaces/clear-cache.interface';
import { APIError } from '@support/api/common/error.interface';
import { CACHE_MODULE_COMPONENTS } from '@support/shared/constants/user.constants';
import { ASSISTED_API_MAP } from '@core/api/proxies/assisted-api-endpoints';
import { map, catchError } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
@Wove({ moduleName: CACHE_MODULE_COMPONENTS.CACHE_MODULE_NAME })
/**
 * Service that manages UI cache
 *
 * @export
 * @class CacheManagerService
 */
@Injectable(
  { providedIn: 'root' }
)
export class CacheManagerService {
  /* refresh button Source event*/
  public refreshPageSource: Subject<boolean>;
  /* refresh button event listener*/
  public refreshPage$: Observable<boolean>;
  /* refresh button enable event*/
  public enableRefreshButtonSource: Subject<boolean>;
  /* refresh button enable event listener*/
  public enableRefreshButton$: Observable<boolean>;
  /* notify repdash source*/
  public notifyRepdashSource: Subject<boolean>;
  /* notify repdash event listener*/
  public notifyRepdashEvent$: Observable<boolean>;

  /**
   * Cache Manager Service
   * @memberof CacheManagerService
   */
  constructor(
    private stateStoreUtilsService: StateStoreUtilsService,
    private apiGatewayService: ApiGatewayService
  ) {
    this.refreshPageSource = new Subject();
    this.refreshPage$ = this.refreshPageSource.asObservable();
    this.enableRefreshButtonSource = new Subject();
    this.enableRefreshButton$ = this.enableRefreshButtonSource.asObservable();
    this.notifyRepdashSource = new Subject();
    this.notifyRepdashEvent$ = this.notifyRepdashSource.asObservable();
  }

  /**
   * Triggers refresh event
   */
  public refreshCacheData(): void {
    this.refreshPageSource.next(true);
  }

  /**
   * Triggers event to enable refresh button
   */
  public enableRefreshButton(): void {
    this.enableRefreshButtonSource.next(true);
  }

  /**
   * Triggers event to disable refresh button
   */
  public disableRefreshButton(): void {
    this.enableRefreshButtonSource.next(false);
  }

  /**
   * Triggers event to notify repdash to update infoBar
   */
  public notifyRepdashToUpdateInfoBar(): void {
    this.notifyRepdashSource.next(true);
  }

  /**
   * Clear Cache For given interaction Ids
   * @return object
   */
  public clearCacheForInteractionIds(): Observable<ClearCacheResponse> {
    const transactionIds = this.stateStoreUtilsService.getActivityIdsforCacheClearing();
    return this.apiGatewayService
      .postRequest(ASSISTED_API_MAP.API_2725_clearAllFromActivityForActivityIds, transactionIds)
      .pipe(
        map((response: HttpResponse<ClearCacheResponse>) => {
          this.stateStoreUtilsService.clearCacheActivityIDs();
          return response.body;
        }),
        catchError((error: APIError) => {
          return observableThrowError(error);
        })
      );
  }
}
